import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { InfoField } from '../../../../index.js';
import EmailIcon from '../../../../../assets/images/module/general/EmailIcon.svg';
import PhoneIcon from '../../../../../assets/images/module/general/PhoneIcon.svg';
import TenantIcon from '../../../../../assets/images/module/general/TenantIcon.svg';
import AreaIcon from '../../../../../assets/images/module/general/AreaIcon.svg';
import Autoload from '../../../../Autoload';
import { formatNumber } from '../../../../../helpers/stringsManipulations.js';
import { Group, Tooltip } from '@mantine/core';
import { NumericFormat } from 'react-number-format';
import accounting from 'accounting';
import dayjs from 'dayjs';

const { checkProperty } = Autoload.MainHelper;
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

export default function TiledContent({ data, tenant, onClick, rentalPayment, history, editRentalUnit, editTenant }) {
  const [rentalData, setRentalData] = useState(data);
  
  useEffect(() => {
    setRentalData(data);
  }, [data]);

  const getCurrentRent = (tenant) => {
    const today = dayjs();

    const currentRent = tenant.rents.find(rent => {
      const isStarted = dayjs(rent.startDate).isBefore(today) || dayjs(rent.startDate).isSame(today, 'day');
      const isNotEnded = rent.endDate === null || 
                        dayjs(rent.endDate).isAfter(today) || 
                        dayjs(rent.endDate).isSame(today, 'day');
      return isStarted && isNotEnded;
    });

    return currentRent;
  };

  const activeRent = getCurrentRent(tenant);
  const tenantName = checkProperty(tenant, 'name', '');
  const tenantEmail = checkProperty(tenant, 'email', '');
  const tenantPhone = checkProperty(tenant, 'phone', '');

  const openTenantDetails = (e) => {
    e.stopPropagation();
    editTenant();
  }

  const opentRentalUnitEditModal = (e) => {
    e.stopPropagation();
    editRentalUnit();
  }
  
  return (
    <div onClick={onClick} style={{marginTop: '-15px'}}>
      <Row>
        <Col xs={12} md={6} onClick={(e)=> openTenantDetails(e)} style={{cursor: tenant?.vacant ? 'not-allowed' : 'pointer'}}>
          <InfoField
            className="pt-3 name-dashboard-rentalunits"
            labelText={lang.general.text_tenants}
            text={tenantName ? tenantName : '-'}
            labelClassName="text-xs"
            leftTextImage={{ img: TenantIcon, style: { width: '7.5px', height: '9.25px' } }}
          />
        </Col>
        <Col xs={6} className="d-none d-md-block" onClick={(e)=> opentRentalUnitEditModal(e)} style={{cursor: 'pointer'}}>
          <InfoField
            className="pt-3"
            labelText={lang.property.generalinfo_Area_of_unit}
            text={checkProperty(rentalData, 'size') && formatNumber(rentalData.size, false) + ' m²'}
            labelClassName="text-xs"
            leftTextImage={{ img: AreaIcon, style: { width: '12px', height: '12px' } }}
          />
        </Col>
        <Col xs={6} className="d-none d-md-block" onClick={(e)=> openTenantDetails(e)} style={{cursor: tenant?.vacant ? 'not-allowed' : 'pointer'}}>
          <InfoField
            className="pt-3"
            labelText={lang.general.text_email}
            text={tenantEmail ? tenantEmail : '-'}
            labelClassName="text-xs"
            leftTextImage={{ img: EmailIcon, style: { width: '12px', height: '8px' } }}
          />
        </Col>
        <Col xs={6} className="d-none d-md-block" onClick={(e)=> openTenantDetails(e)} style={{cursor: tenant?.vacant ? 'not-allowed' : 'pointer'}}>
          <InfoField
            className="pt-3"
            labelText={lang.general.text_phone_number}
            text={tenantPhone ? tenantPhone : '-'}
            labelClassName="text-xs"
            leftTextImage={{ img: PhoneIcon, style: { width: '11.5px', height: '11.5px' } }}
          />
        </Col>
        <Col xs={6} md={6}>
          <InfoField
            className="pt-3"
            labelText={'Zahlungseingang (akt. Monat)'}
            text={rentalPayment ? 
            <Tooltip 
            label={`Erwartet: ${accounting.formatMoney(rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment, '€', 2, '.', ',', '%v %s')} | Eingegangen: ${accounting.formatMoney(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment, '€', 2, '.', ',', '%v %s')}`} 
            position="top"
            >
              <Group wrap="nowrap" align={'center'} style={{maxWidth: '140px'}} 
              onClick={(e)=> {
                e.stopPropagation();
                history.push(`/user/rentIncomeTracking?selectedTenant=${encodeURIComponent(JSON.stringify([tenant?.id]))}&startDate=${dayjs().startOf('month').format('YYYY-MM-DDT00:00:00')}&endDate=${dayjs().endOf('month').format('YYYY-MM-DDT23:59:59')}`);
              }}>
                <Group wrap="nowrap" gap={0} style={{background: (rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) === (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? '#e8f4ea' : (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) > 0)) ? '#f7e3cd' : '#FFCBCB', width: 'auto', height: '21.7px', borderRadius: '15px', padding: '0px 7px'}} justify='space-between' align={'center'}>
                  <div
                  className={`form-control transparent-rent-income ${(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) === (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? 'rental-income-payment-column-full-paid' : (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) > 0)) ? 'rental-income-payment-column-partial-paid' : 'rental-income-payment-column-not-paid'}`}>
                    <span>{accounting.formatMoney(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment, '€', 2, '.', ',', '%v %s')}</span>
                  </div>
                </Group>
              </Group> 
            </Tooltip>
              : '-'} 
            labelClassName="text-xs"
          />
        </Col>
        <Col xs={6} md={6} onClick={(e)=> openTenantDetails(e)} style={{cursor: tenant?.vacant ? 'not-allowed' : 'pointer'}}>
          <InfoField
            className="pt-3"
            labelText={'Kaltmiete je m²'}
            text={(activeRent?.netRent && rentalData.size) ? accounting.formatMoney(activeRent?.netRent / rentalData.size, 'EUR / m²', 2, '.', ',', '%v %s') : '-'} 
            labelClassName="text-xs"
          />
        </Col>
      </Row>
    </div>
  );
}
